import api from "./axios";
import {
  CriarTvDispositivoResposta,
  ImportarCssResposta,
  SalvarTemaRequest,
  SalvarTvDispositivoRequest,
  SalvarTvPlaylistRequest,
  TemaViewModel,
  TvDispositivoViewModel,
  TvPlaylistViewModel,
} from "../interfaces/PaineisTvTema";

/* Administração (`bi.tenant.manage`). Erros de validação: 400 `{ message, erros: string[] }`. */

const ADMIN = "/bi/admin";

export const getTvPlaylists = async (clientId: number): Promise<TvPlaylistViewModel[]> =>
  (await api.get(`${ADMIN}/${clientId}/tv/playlists`)).data;

/** 201 `{ id }`. */
export const criarTvPlaylist = async (clientId: number, dados: SalvarTvPlaylistRequest): Promise<{ id: number }> =>
  (await api.post(`${ADMIN}/${clientId}/tv/playlists`, dados)).data;

/** 204. */
export const atualizarTvPlaylist = async (
  clientId: number,
  id: number,
  dados: SalvarTvPlaylistRequest
): Promise<void> => {
  await api.put(`${ADMIN}/${clientId}/tv/playlists/${id}`, dados);
};

/** 204. Desativa; dispositivos dela passam a receber 401. */
export const excluirTvPlaylist = async (clientId: number, id: number): Promise<void> => {
  await api.delete(`${ADMIN}/${clientId}/tv/playlists/${id}`);
};

export const getTvDispositivos = async (clientId: number): Promise<TvDispositivoViewModel[]> =>
  (await api.get(`${ADMIN}/${clientId}/tv/dispositivos`)).data;

/** 201. A chave só aparece nesta resposta. */
export const criarTvDispositivo = async (
  clientId: number,
  dados: SalvarTvDispositivoRequest
): Promise<CriarTvDispositivoResposta> => (await api.post(`${ADMIN}/${clientId}/tv/dispositivos`, dados)).data;

/** 204. */
export const atualizarTvDispositivo = async (
  clientId: number,
  id: number,
  dados: SalvarTvDispositivoRequest
): Promise<void> => {
  await api.put(`${ADMIN}/${clientId}/tv/dispositivos/${id}`, dados);
};

/** 204. */
export const revogarTvDispositivo = async (clientId: number, id: number): Promise<void> => {
  await api.post(`${ADMIN}/${clientId}/tv/dispositivos/${id}/revogar`);
};

/** `null` quando o cliente não tem tema (204). */
export const getTema = async (clientId: number): Promise<TemaViewModel | null> => {
  const r = await api.get(`${ADMIN}/${clientId}/tema`);
  return r.status === 204 || !r.data ? null : r.data;
};

/** 204. */
export const salvarTema = async (clientId: number, dados: SalvarTemaRequest): Promise<void> => {
  await api.put(`${ADMIN}/${clientId}/tema`, dados);
};

/** 204. Volta ao padrão. */
export const removerTema = async (clientId: number): Promise<void> => {
  await api.delete(`${ADMIN}/${clientId}/tema`);
};

/** Não grava; só devolve os tokens reconhecidos e as variáveis não mapeadas. */
export const importarCss = async (clientId: number, css: string): Promise<ImportarCssResposta> =>
  (await api.post(`${ADMIN}/${clientId}/tema/importar-css`, { css })).data;

/* Sessão (qualquer usuário autenticado; sem a flag de Painéis) */

/** Tema da organização do token; `null` sem org ou sem tema (204). */
export const getMeuTema = async (): Promise<TemaViewModel | null> => {
  const r = await api.get("/me/tema");
  return r.status === 204 || !r.data ? null : r.data;
};
